import React from "react";

const jugadores = [
  { nombre: "Juan Pérez", foto: "/jugadores/juan-perez.jpg" },
  { nombre: "Carlos Gómez", foto: "/jugadores/carlos-gomez.jpg" },
  { nombre: "Martín Rodríguez", foto: "/jugadores/martin-rodriguez.jpg" },
];

// Cambiar a true cuando esté lista la encuesta
const formularioDisponible = false;
const urlFormulario = "https://forms.gle/ejemplo"; // Pegá el link real cuando lo tengas

export default function JugadorDelPartido() {
  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-red-600 mb-6 uppercase">
          🏀 Votá al Jugador del Partido
        </h2>

        {!formularioDisponible ? (
          <p className="text-gray-600 text-xl mt-20">
            📢 <span className="font-semibold">Post Partido:</span> estará disponible la encuesta aquí.
          </p>
        ) : (
          <>
            <p className="text-gray-700 mb-10 text-lg">
              Elegí quién fue el mejor jugador según vos.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {jugadores.map((jugador, index) => (
                <div key={index} className="bg-gray-100 rounded-xl p-4 shadow">
                  <img
                    src={jugador.foto}
                    alt={jugador.nombre}
                    className="w-full h-64 object-cover rounded-lg mb-4"
                  />
                  <h3 className="text-xl font-semibold mb-2">{jugador.nombre}</h3>
                  <a
                    href={urlFormulario}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 inline-block"
                  >
                    Votar
                  </a>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
